import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/dialpad-ai-color.vue
var s = {
	name: "DtIconDialpadAiColor",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["fill"], d = ["id"], f = ["id"];
function p(e, t, n, s, p, m) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([m.iconSizeClass, "d-icon d-icon--dialpad-ai-color"]),
		"data-qa": m.dataQA,
		"aria-hidden": m.ariaHidden,
		role: "img",
		"data-name": "Dialpad Ai Color",
		viewBox: "0 0 24 25",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			d: "M21.442 7.332a1.916 1.916 0 1 0 0-3.832 1.916 1.916 0 0 0 0 3.832Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M9.182 6.888c-.434 0-1.182.413-1.57 1.683l-.001.002-3.683 11.873a1.498 1.498 0 0 1-2.86-.888l3.68-11.864V7.69c.6-1.952 2.168-3.798 4.434-3.798 2.265 0 3.831 1.842 4.431 3.79 0 0 0 .001 0 0l2.835 9.142c.39 1.265 1.136 1.68 1.57 1.68a1.926 1.926 0 0 0 1.926-1.927V10.32a1.497 1.497 0 1 1 2.995 0v6.257a4.921 4.921 0 0 1-4.921 4.922c-2.263 0-3.831-1.842-4.431-3.791 0-.001 0 0 0 0l-2.837-9.14c-.389-1.267-1.134-1.68-1.57-1.68Z",
			fill: `url(#${e.uniqueID}b)`
		}, null, 8, u),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "2.799",
			y1: "3.5",
			x2: "17.027",
			y2: "24.562",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [
			i("stop", { "stop-color": "#FF5E2F" }, null, -1),
			i("stop", {
				offset: ".25",
				"stop-color": "#FF1356"
			}, null, -1),
			i("stop", {
				offset: ".66",
				"stop-color": "#FF1BA4"
			}, null, -1),
			i("stop", {
				offset: "1",
				"stop-color": "#9D42EA"
			}, null, -1)
		])], 8, d), i("linearGradient", {
			id: `${e.uniqueID}b`,
			x1: "2.799",
			y1: "3.5",
			x2: "17.027",
			y2: "24.562",
			gradientUnits: "userSpaceOnUse"
		}, [...t[1] || (t[1] = [
			i("stop", { "stop-color": "#FF5E2F" }, null, -1),
			i("stop", {
				offset: ".25",
				"stop-color": "#FF1356"
			}, null, -1),
			i("stop", {
				offset: ".66",
				"stop-color": "#FF1BA4"
			}, null, -1),
			i("stop", {
				offset: "1",
				"stop-color": "#9D42EA"
			}, null, -1)
		])], 8, f)])
	], 10, c);
}
var m = /* @__PURE__ */ n(s, [["render", p]]);
//#endregion
export { m as default };

//# sourceMappingURL=dialpad-ai-color.js.map